import styled from 'styled-components';
import colors from '../../utils/style/colors';
import { useContext } from 'react';
import { ThemeContext } from '../../utils/context';

const ThemeButton = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  opacity: 1;
  transition: 0.3s;
  background: ${props => (props.theme === 'light' ? '#141414' : '#ffffff')};
  z-index: 4;
  position: fixed;
  bottom: 10px;
  left: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* opacity: 0.6; */

  &:hover {
    opacity: 1;
  }
  ion-icon {
    color: #f1a900;
    color: ${props => (props.theme === 'light' ? '#f1a900' : '#141414')};
    font-size: 17px;
  }
`;

function ThemeComp() {
  const { theme, toggleTheme } = useContext(ThemeContext);

  const handleClick = () => {
    toggleTheme();
  };

  return (
    <ThemeButton onClick={handleClick} theme={theme}>
      {theme === 'light' ? (
        <ion-icon name="moon-outline"></ion-icon>
      ) : (
        <ion-icon name="sunny-outline"></ion-icon>
      )}
    </ThemeButton>
  );
}

export default ThemeComp;
